import {Component, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {roles, showItem} from '@modules/shared/shared.component';
import {ApiService} from '@modules/shared/services/api.service';
import {UnreadMsgService} from '@modules/shared/services/unread-msg.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  isActive = false;
  collapsed = false;
  showMenu = '';
  unreadCount = 0;
  pushRightClass = 'push-right';
  userPermissionsArray;
  @Output() collapsedEvent = new EventEmitter<boolean>();
  showItem = showItem;

  constructor(public router: Router, private apiService: ApiService, private unreadService: UnreadMsgService) {
    this.userPermissionsArray = localStorage.getItem('permissions');
    if (this.userPermissionsArray) {
      this.userPermissionsArray = this.userPermissionsArray.split(',');
    } else {
      this.userPermissionsArray = [];
    }
    this.router.events.subscribe(val => {
      if (
        val instanceof NavigationEnd &&
        window.innerWidth <= 992 &&
        this.isToggled()
      ) {
        this.toggleSidebar();      }
    });

    this.unreadService.selectedUnread$.subscribe((value) => {
      this.getUnreadCount();
    });
  }

  ngOnInit() {
    this.getUnreadCount();
  }

  getUnreadCount() {
    this.apiService.getUnreadMessages().subscribe(response => {
      if (response.success) {
        this.unreadCount = response.data;
      }
    });
  }
  ngOnDestroy() {}
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
    this.collapsedEvent.emit(this.collapsed);
  }

  isToggled(): boolean {
    const dom: Element = document.querySelector('body');
    return dom.classList.contains(this.pushRightClass);
  }
  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }

}
